export const GET_PRODUCTS_DATA="get/products"
export const UPDATE_PRODUCT='update/product'